import React, { Component } from 'react';
import { connect } from 'react-redux';
import $ from 'jquery';
import 'jquery-mask-plugin'
import './_sidemenu.css';
import Avatar from '../Avatar';


const icons = {
    person : require('../../img/icons/19@x2.png'),
    phone : require('../../img/icons/20@x2.png'),
    mail : require('../../img/icons/21@x2.png'),
    marker : require('../../img/icons/7@x2.png')
}

// const MEDIAS = [
//     <img src="http://lorempixel.com/400/200" style={{width:'100%', height:'auto', display: 'flex',flex:1, backgroundSize:'cover'}}/>,
//     <img src="http://lorempixel.com/400/200" style={{width:'100%', height:'auto', display: 'flex',flex:1, backgroundSize:'cover'}}/>,
//     <img src="http://lorempixel.com/400/200" style={{width:'100%', height:'auto', display: 'flex',flex:1, backgroundSize:'cover'}}/>,
//     <img src="http://lorempixel.com/400/200" style={{width:'100%', height:'auto', display: 'flex',flex:1, backgroundSize:'cover'}}/>,
//     <img src="http://lorempixel.com/400/200" style={{width:'100%', height:'auto', display: 'flex',flex:1, backgroundSize:'cover'}}/>,
//     <img src="http://lorempixel.com/400/200" style={{width:'100%', height:'auto', display: 'flex',flex:1, backgroundSize:'cover'}}/>,
//     <img src="http://lorempixel.com/400/200" style={{width:'100%', height:'auto', display: 'flex',flex:1, backgroundSize:'cover'}}/>,
//     <img src="http://lorempixel.com/400/200" style={{width:'100%', height:'auto', display: 'flex',flex:1, backgroundSize:'cover'}}/>,
//     <img src="http://lorempixel.com/400/200" style={{width:'100%', height:'auto', display: 'flex',flex:1, backgroundSize:'cover'}}/>,
//     <img src="http://lorempixel.com/400/200" style={{width:'100%', height:'auto', display: 'flex',flex:1, backgroundSize:'cover'}}/>,

// ]
// const Media = (props)=>{
//     function renderMedias(){
//         const {data} = props;
//         return  data.length > 0 ? data.map((media)=>{
//             return <div className='media-item'>{media}</div>
//         }):null;
//     }

//     return(
//         <div className='media-container'>
//             {renderMedias()}
//         </div>
//     )

// }
class SideMenu extends Component{

    constructor(props){
        super(props)
        this.addMask = this.addMask.bind(this)
    }

    addMask(){
        $('#phone').mask('(00) 00000-0000');

        if($('#document').text().length >=14) {
            $('#document').mask('00.000.000/0000-00', {reverse: true});
        } else {
            $('#document').mask('000.000.000-00', {reverse: true});
        }
    }

    componentWillReceiveProps(nextProps){
        if(nextProps.menu.menuOpen){
            $('.menu').css({right : 0});
            $('.conteudo').css({'margin-right' : 300});

            this.addMask()

        }else{
            // adicionado transition aqui para que na primeira vez que carregar ele não faça a animação,
            // apenas quando o usuario interagir vai fazer a animação
            $('.menu').css({right : -300, transition: "right .5s, opacity.2s"});
            $('.conteudo').css({'margin-right' : 0, transition: 'margin-right .5s'});
        }
    }

    render(){
        const { contact } = this.props
        const _contact = contact  ? contact : {};
        const { st_celular_pes, st_email_pes, st_cpfresp_pes, st_cnpj_pes, st_nome_pes, id_pessoa_pes } = _contact
        let docNumber = st_cpfresp_pes&&st_cpfresp_pes !=='' ? st_cpfresp_pes : st_cnpj_pes
        docNumber = String(docNumber)

        let userMail = st_email_pes ? st_email_pes.split(";") : [];
        const urlPerfilSuperlogica = `https://apps.superlogica.net/imobiliaria/pessoas/id/${id_pessoa_pes}`

        return(
            <div className='menu'>
                <div className='menu-content'>
                    <div className='dados-basicos'>
                        <div className='dados-basicos-content'>
                            <span className='dados-basicos-title'>Dados Básicos</span>
                            <a href={urlPerfilSuperlogica} title="Ver perfil completo" target="_blank" className='dados-basicos-subtitle'>Perfil completo</a>
                        </div>
                        <div className='user-info-container'>
                            <div style={styles.profilePicture}>
                                <Avatar src={_contact.st_fotourl_pes} size={200}/>
                            </div>
                            { 
                                 st_nome_pes !== '' &&
                                    <div className='user-info-container-item' style={{ fontSize: 20 }}>
                                        <span className='user-info'>{ st_nome_pes }</span>
                                    </div>
                            }
                            { 
                                docNumber !== '' &&
                                    <div className='user-info-container-item'>
                                        <img src={icons['person']} alt=''/>
                                        <span className='user-info' id="document">{ docNumber }</span>
                                    </div>
                            }
                            {
                                st_celular_pes&&st_celular_pes !== ''&&
                                    <div className='user-info-container-item'>
                                        <img src={icons['phone']} alt=''/>
                                        <span className='user-info' id="phone">{st_celular_pes}</span>
                                    </div> 
                            }
                            {
                                st_email_pes&&st_email_pes !== ''&&
                                    <div className='user-info-container-item'>
                                        <img src={icons['mail']} alt=''/>
                                        <div style={{display: 'grid', width: '100%', whiteSpace: 'nowrap', overflow: 'hidden'}}>
                                            {
                                                userMail.map((mail, index) => (
                                                    <span key={index} className='user-info'>{mail}</span>
                                                ))
                                            }
                                        </div>
                                    </div>
                            }
                        </div>
                    </div>
                </div>
            </div>)
    }
}

const styles = {
    profilePicture: {
        display: 'flex',
        justifyContent: 'center',
        marginBottom: 15
    }
};


const mapStateToProps = (state)=>{
    return{
        menu: state.menu,
        contact: state.contatos.entities.contact
    }
}
export default connect(mapStateToProps)(SideMenu);


// WEBPACK FOOTER //
// ./src/components/sidemenu/SideMenu.js